import { useField } from 'formik';

const TextInputFormik = ({
  label,
  type = "text",
  required,
  placeholder,
  disabled,
  maxLength,
  id,
  ...props
}) => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error ? meta.error : "";

  const handleChange = (e) => {
    const inputValue = e.target.value;
    let errorMessage = "";

    if (required && !inputValue.trim()) {
      errorMessage = "Ce champ est obligatoire.";
  } else if (type === "email" && inputValue && !/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(inputValue)) {
  errorMessage = "Format d'email invalide.";
} else if (type === "tel" && inputValue && !/^\+?[0-9]{7,15}$/.test(inputValue)) {
      errorMessage = "Numéro de téléphone invalide.";
    } else if (type === "siret" && inputValue && !/^FR\d{10}$/.test(inputValue)) {
      errorMessage = "Le SIRET doit commencer par 'FR' suivi de 10 chiffres.";
    }

    // Call Formik's onChange handler
    field.onChange(e);
    
    // Set local error state if needed
    if (errorMessage) {
      meta.error = errorMessage;
    }
  };

  return (
    <div className="input-wrapper">
      {label && (
        <label>
          {label} {required && <span>*</span>}
        </label>
      )}
      <input
        {...field}
        id={id}
        type={type === "siret" ? "text" : type}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={field.onBlur}
        disabled={disabled}
        value={field.value || ''}
        maxLength={maxLength}
      />
      {(error || meta.error) && (
        <span className="error-message mt-8">
          <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Arrow" />
          {error || meta.error}
        </span>
      )}
    </div>
  );
};

export default TextInputFormik;